// extracted by mini-css-extract-plugin
module.exports = {"Card":"card_Card__qV46d","cardImage":"card_cardImage__Xm8F2","cardTitle":"card_cardTitle__YMXOp","cardClassification":"card_cardClassification__Fh6cf"};